import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { initialsOf } from "@/lib/format";
import { cn } from "@/lib/utils";

interface UserAvatarProps {
  name: string;
  /** "brand" marks the signed-in viewer; everyone else is neutral. */
  tone?: "neutral" | "brand";
  className?: string;
}

/** Initials avatar. */
export function UserAvatar({ name, tone = "neutral", className }: UserAvatarProps) {
  return (
    <Avatar className={cn("size-8", className)}>
      <AvatarFallback
        className={cn(
          "text-[11px] font-semibold",
          tone === "brand" ? "bg-accent text-brand-ink" : "bg-muted text-sidebar-foreground",
        )}
      >
        {initialsOf(name)}
      </AvatarFallback>
    </Avatar>
  );
}
